import { Component, forwardRef, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { TagData } from 'ngx-tagify';

import { ILanguageCode } from 'rev-shared/media/transcription/TranscriptionLanguages.Service';

import { autoCompleteSettings, TagValue, TEMPLATE, VbTagsInputComponent } from './VbTagsInput.Component';

import styles from './VbTagsInput.Component.module.less';

export interface IVbLanguageTag extends ILanguageCode {
	readonly?: boolean;
}

@Component({
	selector: 'vb-languages-tags-input',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => VbLanguagesTagsInputComponent),
			multi: true
		}
	],
	template: TEMPLATE
})
export class VbLanguagesTagsInputComponent extends VbTagsInputComponent {

	public ngOnInit(): void {
		super.ngOnInit();

		this.settings = {
			...this.settings,
			...autoCompleteSettings,
			templates: {
				tag(tagData: TagData){
					return `
						<tag title="${(tagData.title || tagData.value)}"
							contenteditable='false'
							spellcheck='false'
							tabIndex="${this.settings.a11y.focusableTags ? 0 : -1}"
							class="${this.settings.classNames.tag} ${tagData.class ? tagData.class : ''}"
							${this.getAttributes(tagData)}>
								<x title='' class="${this.settings.classNames.tagX}" role='button' aria-label='remove tag'></x>
								<div class="${styles.tag}">
									<span title="${tagData.value}">${tagData.value}</span>
								</div>
						</tag>
					`;
				},
				dropdownItem(item: TagData) {
					return `
						<div ${this.getAttributes(item)} class="${styles.dropdownItem} ${this.settings.classNames.dropdownItem}"
							tabindex="0"  role="option">
							<span title="${item.value}">${item.value}</span>
						</div>
					`;
				}
			}
		};
	}

	public ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);

		if (changes.whitelist && this.tagifyTags?.length && this.tagifyTags?.some(tag => tag.readonly)) {
			// readonly tags are not being removed by the tagify component when the whitelist changes
			this.manuallyEnforceWhitelist();
		}
	}

	public manuallyEnforceWhitelist(): void {
		const tagify = this.TagifyService.get(this.tagifyName);
		const validTags = this.tagifyTags.filter((tag: IVbLanguageTag) =>
			this.whitelist.some((whitelistItem: IVbLanguageTag) => whitelistItem.code === tag.code)
		);

		tagify.removeAllTags();
		tagify.addTags(validTags);
	}

	public ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	public mappedWhitelist(): TagValue[] {
		return this.whitelist.map(lang => ({ ...lang, value: lang.name }));
	}

	public onTagsChange($event: any[]): void {
		const tags = $event?.map(item => ({ code: item.code, name: item.name }));
		this.notifyChange(tags);
	}
}
